import FlowWizard from "@shared/components/form/FlowWizard";
import { StepType, ICustomButton } from "@shared/components/form/types";
import { ActivityName, IDrugIntakeRequest } from "app/_modules/core/types";
import { DrugIntakeInfoStep, IDrugIntakeInfoStepContext } from "../steps";
import { useNavigation } from "@react-navigation/native";
import { NativeStackNavigationProp } from "@react-navigation/native-stack";
import { TNavigationStack } from "app/types";
import { usePost } from "app/queryProvider";
import { useAuth } from "app/auth/hooks/useAuth";
import { Loading } from "@shared/components/loading";
import { Form } from "@ant-design/react-native";
import { TActivityBucket } from "app/_modules/core/utils/activityCard";
import { isSlotNow } from "app/_modules/core/utils/drugIntake";
import { getServerNow } from "@shared/utils/serverClock";

export enum EActivitySubmitSteps {
  DRUG_INTAKE_INFO = "drugIntakeInfo",
}

export interface IDrugIntakeFlowData {
  drugIntakeInfo: { administered: boolean };
}

const DrugIntakeFlow = ({ activityName, activityId, bucket, initialStep = 0, forceReset = false }: { activityName: ActivityName, activityId: string, bucket: TActivityBucket, initialStep?: number, forceReset?: boolean }) => {
  const [drugIntakeForm] = Form.useForm();
  const { meData } = useAuth()
  const navigation = useNavigation<NativeStackNavigationProp<TNavigationStack>>();

  const telemonitoringPathwayId = meData?.current_pathway.id || "";



  const { mutate: createDrugIntake, isPending: isCreatingDrugIntake } = usePost<IDrugIntakeRequest, undefined>({
    options: {
      onSuccess: () => {
        navigation.navigate("ActivitySuccess", { administered: true, activityType: 'drug', prescribedWindow: bucket });
      },
    },
  });

  const drugIntakeInfo: StepType<
    EActivitySubmitSteps.DRUG_INTAKE_INFO,
    { administered: boolean },
    IDrugIntakeInfoStepContext
  > = {
    component: DrugIntakeInfoStep,
    key: EActivitySubmitSteps.DRUG_INTAKE_INFO,
    context: { activityName },
    form: drugIntakeForm,
    initialValues: { administered: false },
    showBackButton: false,
  };

  const steps = [
    drugIntakeInfo,
  ];

  const handleFinish = () => {
    const isInSlot = bucket === 'daily' || isSlotNow(bucket, getServerNow());

    if (!isInSlot) {
      navigation.navigate("DrugIntakeWindowSelect", { activityId, prescribedWindow: bucket });
      return;
    }

    createDrugIntake({
      resource: { name: "pathways", id: telemonitoringPathwayId },
      url: `/activities/${activityId}/drug-intake`,
      data: {
        administered: true,
      },
    });
  };


  if (isCreatingDrugIntake) {
    return <Loading />
  }

  return (
    <FlowWizard<IDrugIntakeFlowData>
      steps={steps}
      onFinish={handleFinish}
      animationType="scale"
      initialStep={forceReset ? 0 : initialStep}
      layout="vertical"
      finishText="buttons.tookMedicine"
      customButtons={{
        customAction: {
          text: "buttons.notTookMedicine",
          onPress: () => {
            navigation.navigate("DrugIntakeSubmit", { activityId });
          },
          variant: "outline",
        },
      }}
    />
  );
};


export default DrugIntakeFlow;
